module.exports = __webpack_public_path__ + "static/media/Loader.5f8e86ca.gif";